import { Storybook } from "@tento-ui/ui/storybook";
import { Toast } from "@tento-ui/components/toast/toast";
import { DateTime } from "@tento-chrono";
import { GracePeriodBanner } from "./grace-period-banner";

export class GracePeriodBannerStoryBook extends Storybook.Default {
  title(): string {
    return "Grace Period Banner";
  }

  examples(): Storybook.Example[] {
    return [
      {
        title: "7 days left",
        render: () => this.make(7),
      },
      {
        title: "1 day left",
        render: () => this.make(1),
      },
      {
        title: "0 days left",
        render: () => this.make(0),
      },
    ];
  }

  private make(daysLeft: number): GracePeriodBanner {
    const expiresAt = DateTime.utc.now().add({ days: daysLeft, hrs: 1 });
    const $banner = GracePeriodBanner.make();
    $banner.bind(expiresAt);
    $banner.onUpgrade = () => Toast.info("Upgrade clicked");
    $banner.assignStyles({ width: "240px" });
    return $banner;
  }
}
